import { useQuery } from "@tanstack/react-query";

import type { paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGet, qk } from "@/shared/api";

export type AccrualRow = Result<paths["/api/v1/admin/accruals/history"]["get"]>[number];

export function useAccrualHistory(userId: number | null) {
  return useQuery({
    queryKey: qk.accrualHistory(userId),
    enabled: userId !== null,
    queryFn: ({ signal }) =>
      apiGet("/api/v1/admin/accruals/history", {
        query: { user_id: userId ?? 0, limit: 200 },
        signal,
      }),
  });
}
